/**
 * Atledi's single on/off switch.
 *
 * The assistant is shown across the app but not shipped yet: the product
 * decision is to let people see where it will live, clearly marked as coming,
 * rather than hide it and surprise them later. Everything Atledi-shaped reads
 * this flag — the launcher, the drawer and the home callout — so turning it on
 * is one edit here, not a hunt through components.
 *
 * While it is false nothing may call the assistant API: the drawer never
 * mounts, so the cost-control request cannot leave the browser.
 */
export const ATLEDI_ENABLED = false;
